
import baseTemplate from 'text!./UnderwritingIssues.html';
import styles from './UnderwritingIssues-hashed.scss';
import cssUtil from 'gw-portals-util-js/CssUtil';


const template = cssUtil.hashTemplate(baseTemplate, styles);

export default {
    bindings: {
        uwIssueText: '@',
        submissionNumber: '@'
    },
    template
};